module.exports = require("./cu-RU.js");